import React from 'react';
import SectionHeading from '../UI/SectionHeading';
import Button from '../UI/Button';
import './PricingSection.css';

interface PricingPlan {
  id: string;
  name: string;
  price: string;
  period: string;
  features: string[];
  isFeatured?: boolean;
  comingSoon?: boolean;
  description?: string;
}

const PricingSection: React.FC = () => {
  const plans: PricingPlan[] = [
    {
      id: "basic",
      name: "Базовый",
      price: "По запросу",
      period: "за генерацию",
      description: "Самое простое решение для небольших проектов",
      features: [
        'Самое простое решение',
        'Оплата за количество генераций проектов',
        'Базовая техподдержка',
        'Доступ к обновлениям',
        'Работа с готовыми шаблонами'
      ],
      comingSoon: true
    },
    {
      id: "optimal",
      name: "Оптимальный",
      price: "По запросу",
      period: "ежемесячно",
      description: "Идеально для регулярного использования",
      features: [
        'Неограниченные генерации',
        'Фиксированная ежемесячная оплата',
        'Расширенная техподдержка',
        'Приоритетные обновления',
        'Адаптация под ваши проекты'
      ],
      comingSoon: true
    },
    {
      id: "premium",
      name: "Премиум",
      price: "По запросу",
      period: "годовая лицензия",
      description: "Полнофункциональное решение для профессионалов",
      features: [
        'Коробочное решение',
        'Годовая или бессрочная лицензия',
        'Установка на ваш сервер',
        'Премиум поддержка 24/7',
        'Возможность самостоятельной доработки'
      ],
      isFeatured: true
    },
    {
      id: "architect",
      name: "Kvadro Архитектор",
      price: "По запросу",
      period: "под ключ",
      description: "Комплексное ведение архитектурных проектов",
      features: [
        'Полное ведение проектов',
        'Адаптация под вашу стилистику',
        'Готовые планировочные решения',
        'Консультации архитектурных экспертов',
        'Индивидуальный подход к каждому проекту'
      ]
    }
  ];

  return (
    <section id="pricing" className="pricing-section section">
      <div className="container">
        <SectionHeading 
          title="Тарифные планы"
          subtitle="Выберите оптимальный вариант для вашего бизнеса"
        />
        
        <div className="pricing-cards-container">
          {plans.map((plan) => (
            <div 
              key={plan.id} 
              className={`pricing-card-wrapper ${plan.isFeatured ? 'featured' : ''} ${plan.comingSoon ? 'coming-soon' : ''}`}
            >
              <div className="pricing-card">
                {plan.isFeatured && (
                  <div className="pricing-badge recommended-badge">
                    <span className="badge-text">Рекомендуемый</span>
                  </div>
                )}
                {plan.comingSoon && (
                  <div className="pricing-badge coming-soon-badge">
                    <span className="badge-text">Скоро</span>
                  </div>
                )}
                
                <div className="pricing-header">
                  <h3 className="pricing-name">{plan.name}</h3>
                  <div className="pricing-details">
                    <div className="pricing-price">{plan.price}</div>
                    <div className="pricing-period">{plan.period}</div>
                  </div>
                </div>
                
                <div className="pricing-divider"></div>
                
                {plan.description && (
                  <div className="pricing-description">{plan.description}</div>
                )}
                
                <ul className="pricing-features">
                  {plan.features.map((feature, idx) => (
                    <li key={idx} className="pricing-feature">
                      <div className="feature-icon">✓</div>
                      <div className="feature-text">{feature}</div>
                    </li>
                  ))}
                </ul>
                
                <div className="pricing-action">
                  <Button 
                    href="#contact" 
                    variant={plan.isFeatured ? 'gradient' : 'primary'}
                    disabled={plan.comingSoon}
                    className="pricing-button"
                  >
                    {plan.comingSoon ? 'Скоро в продаже' : 'Получить предложение'}
                  </Button>
                </div>
              </div>
              
              {/* 3D floating effect elements */}
              <div className="floating-elements">
                <div className="floating-square top-left"></div>
                <div className="floating-square top-right"></div>
                <div className="floating-square bottom-left"></div>
                <div className="floating-square bottom-right"></div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="pricing-note">
          <p>
            Не нашли подходящий план? <a href="#contact" className="pricing-contact-link">Свяжитесь с нами</a> для индивидуального предложения.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;